var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhr5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logo-redox-default",
    width: 2025,
    height: 670,
    viewBox: "0 0 2025 670",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m245,190v100H100v380H0v-355l125-125h120Zm165,0l-125,125v285l70,70h260v-100h-230v-90h145l125-125v-95l-70-70h-175Zm145,100v90h-170v-90h170ZM1105,0h-100v120l70,70h-215l-125,125v285l70,70h130l70-70v70h100V0Zm-100,570h-170v-280h170v280Zm325-380l-125,125v285l70,70h175l125-125v-285l-70-70h-175Zm145,100v280h-170v-280h170Zm180-100v120l160,160h-90l-70,70v130h100v-90l85-85,85,85v90h100v-130l-160-160h90l70-70v-120h-100v80l-85,85-85-85v-80h-100Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhr5);
export default __webpack_public_path__ + "static/media/ehr-5.df4f05b501f342199e19cd26aa39019d.svg";
export { ForwardRef as ReactComponent };